// extracted by mini-css-extract-plugin
export var black = "_r-6";
export var brand = "_r-1";
export var ddefault = "_r-0";
export var error = "_r-3";
export var gray = "_r-2";
export var highContrast = "_r-8";
export var outline = "_r-7";
export var success = "_r-5";
export var warning = "_r-4";